class ResourceUsersController {
  static controller($rootScope, $scope, $state, ResourceService, $mdSidenav, $mdDialog) {
    'ngInject';

    init();

    $scope.showResourceDialog = function(ev, resource) {
      $mdDialog.show({
        controller: ResourceDialogController,
        template: `
          <md-content layout-padding>
            <div layout="column" layout-align="space-around center">
              <div>
                <md-button class="md-primary" aria-label="connect" ng-click="connectResource()">
                  <i class="fa fa-plug fa-lg" md-menu-origin aria-hidden="true" layout-margin></i> {{"RESOURCE.CONNECT" | translate}}
                </md-button>
              </div>
              <div>
                <md-button class="md-primary" aria-label="share" ng-click="shareResource()">
                  <i class="fa fa-share fa-lg" md-menu-origin aria-hidden="true" layout-margin></i> {{"RESOURCE.INSTALATOR_SHARE" | translate}}
                </md-button>
              </div>
              <div>
                <md-button class="md-primary" aria-label="share" ng-click="renameResource()">
                  <i class="fa fa-edit fa-lg" md-menu-origin aria-hidden="true" layout-margin></i> {{"RESOURCE.RENAME" | translate}}
                </md-button>
              </div>
              <div>
                <md-button class="md-primary" aria-label="share" ng-click="removeResource()">
                  <i class="fa fa-remove fa-lg" md-menu-origin aria-hidden="true" layout-margin></i> {{"RESOURCE.REMOVE" | translate}}
                </md-button>
              </div>
            </div>
          </md-content>
        `,
        locals : {
          resource : resource,
          parentScope : $scope
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      });
    };

    function ResourceDialogController($scope, $state, $mdDialog, resource, parentScope, ResourceService) {
  
      $scope.connectResource = function(){
        if(parentScope.currentResource.uniqueId == resource.uniqueId) {
          $mdDialog.cancel();
          return;
        }
  
        $rootScope.errors = null;
        $rootScope.mainProgressVisible = true;
        var promise = ResourceService.login($rootScope.auth.login, resource);
  
        promise.then(function(data) {
          $mdDialog.cancel();
          var newStateName = 'protected.users.resource.' + resource.resourceType;
          $rootScope.mainProgressVisible = false;
          
          if(newStateName === $state.current.name){
            $state.reload();
          }else {
            $state.go($state.get(newStateName) ? newStateName : 'protected.users.resource.notFound');
          }
          
        });
      };

      $scope.shareResource = function() {
        $mdDialog.cancel();
        $state.go('protected.users.client.shareResource', {resourceUniqueId : resource.uniqueId});
      }

      $scope.removeResource = function() {
        ResourceService.removeResource(resource.uniqueId)
        .then(() => {
          $mdDialog.cancel();

          if(resource.uniqueId === ResourceService.getCurrentResource().uniqueId) {
            $state.go('public.users.start');
          }else {
            $scope.resources = [];
            init(); 
          }

        });
      }
      
      $scope.renameResource = function() {
        $mdDialog.cancel();

        // FIXME move dialog outside
        $mdDialog.show({
          controller: function ($scope, $mdDialog, ResourceService, selectedResource) {
            $scope.name = selectedResource.name;
            $scope.save = function() {
              ResourceService.changeResourceSettigns(selectedResource.uniqueId, {name : $scope.name})
              .then(function() {
                $mdDialog.cancel();
                $scope.resources = [];
                init(); 
              })
            }
          },
          template: `
            <md-content layout-padding>
              <div layout="column" layout-align="space-around center">
              <md-input-container flex="100">
                <label for="name">{{ "RESOURCE.NEW_NAME" | translate }}</label>
                <input id="name" ng-model="name" type="text" name="name">
              </md-input-container>  
              <div>
                  <md-button class="md-primary" aria-label="connect" ng-click="save()">
                    <i class="fa fa-save fa-lg" md-menu-origin aria-hidden="true" layout-margin></i> {{"COMMONS.SAVE" | translate}}
                  </md-button>
                </div>
              </div>
            </md-content>
          `,
          locals : {
            selectedResource : resource,
            parentScope : $scope
          },
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
        });
      }

    }

    $scope.toggleLeftMenu = function() {
      $mdSidenav('left').toggle();
    };

    function init() {
      console.log('init');
      ResourceService.loadCurrentUserResources($rootScope.auth.login)
      .then(function(data) {

        $scope.resources = data.resources;
        ResourceService.setCurrentUserResources(data.resources);
        $scope.currentResource = ResourceService.getCurrentResource();
      })
      
    }
  };
}

export default ResourceUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/resource/resource.users.controller.js